module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ISO 9001-2015.568e0c30.png";